export const environment = {
  production: true,
  apiBaseUrl: 'https://kurunji.in/api',
  apiPythonBaseUrl: 'https://kurunji.in/api',
  imageBaseUrl: 'https://kurunji.in/api/public',
  appName: 'Kings Auto Finance',
  supportEmail: 'support@kingsautofinance.com',
  maxInstallments: 40,
  secretkey: 'PRODUCTION_SECRET_KEY',
  webpushVapidKey: 'BDls6Q-mYU6quBSBqSEmLZXifHo5ABCb-1jf1Ulq6yOFkY53-cMMuDe4HTAJN-N8SjBSzIXV3i_1NGRm_RdHqVI'
};
